import * as React from "react";
import { selectCoopProjects } from "../../balancingSelectors/selectBalancingCoopProjects";
import { IdStyles } from "../../less/IdStyles";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { utilTime } from "../../utils/utilTime";
import { TextLoca } from "../generic/text/TextLoca";
import { defaultMapCoopMessageReplacements, mapCoopMessageNotice } from "./mapCoopMessageNotice";
import { MapLocaCoopMessage } from "./MapLocaCoopMessage";
export var CoopMessageNotice = function (_a) {
    var coopMessageItem = _a.coopMessageItem;
    var coopProjects = selectCoopProjects();
    var variable1 = coopMessageItem.variable1 || "";
    var foundProject = matchProject(variable1, coopProjects);
    var additionalData = foundProject
        ? foundProject.locakey
        : variable1;
    var getLocaMap = mapCoopMessageNotice.get(coopMessageItem.messageType);
    var replacementLoca = getLocaMap
        ? getLocaMap(coopMessageItem, utilLoca.get(additionalData))
        : defaultMapCoopMessageReplacements(coopMessageItem, utilLoca.get(additionalData));
    return (React.createElement("div", { className: "tr " + IdStyles.TableRowCoopNotice + " flex flex--aligned padding--small" },
        React.createElement(TextLoca, { id: MapLocaCoopMessage[coopMessageItem.messageType], replacements: replacementLoca, className: IdStyles.TextNormal + " flex__auto" }),
        React.createElement("div", { className: "td__divider h100" }),
        React.createElement("span", { className: IdStyles.TextNormal + " message-notice-date" }, utilTime.getCreatedDateFromSeconds(coopMessageItem.creationTime))));
};
var matchProject = function (projectTypeId, coopProjects) {
    var typeId = parseInt(projectTypeId, 10);
    var isValidProjectId = !isNaN(typeId) && typeId !== -1;
    if (!isValidProjectId) {
        return;
    }
    return coopProjects.find(function (project) { return project.id === typeId; });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/CoopMessageNotice.tsx
// module id = 2617
// module chunks = 3